import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";
export default class Empleados{

    getDirectoriosUnidades(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/GetDirectoriosUnidades")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getEstatusActivos(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/GetEstatusActivos")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getTiposMediosActivos(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/GetTipoMedioActivos")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getTiposLineasActivos(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/GetTipoLineaActivos")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getTiposRegimenesActivos(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/GetTipoRegimen")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    Add(context,params){ 
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/Add",params)        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"Error al obtener datos del servidor",
                life: 3000
            });
            console.log(error);
            reject(error);
            })
        })
    }

    Update(context,params){ 
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/Update",params)        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"Error al obtener datos del servidor",
                life: 3000
            });
            console.log(error);
            reject(error);
            })
        })
    }

    Delete(context,params){ 
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFDirectoriosUnidades.svc/RestService/Delete/" + params)        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"Error al obtener datos del servidor",
                life: 3000
            });
            console.log(error);
            reject(error);
            })
        })
    }
}